/**
 *
 * PortalBody
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 19-Oct-2022
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import style from './PortalBody.scss';

const PortalBody = (props) => (
  <Grid
    className={`
      ${style.container}
      ${props.customStyle && style[props.customStyle]}
      ${props.className}
    `}>
    {props.children}
  </Grid>
);

PortalBody.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  /** Description of prop "baz". */
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  className: PropTypes.string,
  customStyle: PropTypes.string,
};

PortalBody.defaultProps = {
  // Add here some default propTypes values
  className: '',
  customStyle: '',
};

export default PortalBody;
